export default {
  sm: `
  지식과 정보를 
  보관하는 ‘정보의 궤’   
  `,
  lg: `
  지식과 정보를 보관하는 ‘정보의 궤’ 
  `,
};
